import { takeLatest, select, put } from 'redux-saga/effects';
import { Actions } from '@grandvisionhq/configurator';
import { IntlSelectors } from '@grandvisionhq/state';
import { dispatchTrackEvent } from '@grandvisionhq/svc-tealium/events';
import { getBundlePrice, getSelectedAddOn, getFrameSku, getSelectedFrameProductType } from '../configurator/selectors.js';
import '../add-to-cart/selectors.js';
import '../bundles/selectors.js';
import '../bundles/reducer.js';
import '../configurator/reducer.js';
import '../products/selectors.js';
import '../products/reducer.js';
import { tealiumRxConfiguratorViewStep } from './actions.js';
import { mapProductToTealiumImpressionProperties } from './mappers/map-product-to-tealium-impression-properties.js';
import { getConfigFlow, getProduct } from './selectors.js';

function* onTealiumConfiguratorViewStep({ payload  }) {
    yield dispatchTrackEvent(()=>Promise.resolve(payload)
    );
}
function* onConfiguratorViewStep({ payload  }) {
    const configFlow = yield select(getConfigFlow, payload);
    // Not all view steps are required to fire a Tealium event.
    // If there is no Tealium step name defined for the step, it can be ignored
    if (!(configFlow === null || configFlow === void 0 ? void 0 : configFlow.stepName)) return;
    const bundlePrice = yield select(getBundlePrice, payload);
    const selectedAddOn = yield select(getSelectedAddOn);
    const product = yield select(getProduct);
    const activeSku = yield select(getFrameSku);
    const productType = yield select(getSelectedFrameProductType);
    const locale = yield select(IntlSelectors.getLocale);
    const tealiumPayload = mapProductToTealiumImpressionProperties(configFlow, product, activeSku, productType, bundlePrice, selectedAddOn === null || selectedAddOn === void 0 ? void 0 : selectedAddOn.sku, locale);
    if (tealiumPayload) {
        yield put(tealiumRxConfiguratorViewStep(tealiumPayload));
    }
}
const getTeliumSagas = (id)=>{
    return [
        takeLatest(tealiumRxConfiguratorViewStep.type, onTealiumConfiguratorViewStep),
        takeLatest(Actions.isStepShownWithId(id), onConfiguratorViewStep), 
    ];
};

export { getTeliumSagas, onConfiguratorViewStep, onTealiumConfiguratorViewStep };
//# sourceMappingURL=sagas.js.map
